export const visit = (vm, at) => {
at({ "ar-eg": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "\u0631\u0633\u0627\u0644\u0629 \u062C\u062F\u064A\u062F\u0629" } } });
};